import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EmploymentType } from '../models/employment-type';
import { APP_CONFIG, Settings } from '../../config/settings';
import { combine } from '../utilities/route';

@Injectable({
    providedIn: 'root'
})
export class EmploymentTypesService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova/common');
    }

    getEmploymentTypes(): Observable<EmploymentType[]> {
        return this.http.get<EmploymentType[]>(`${this.coreApiPath}/employment-types`);
    }
}
